import { Directive, EventEmitter, Input, Output } from '@angular/core'

export type SortDirection = 'asc' | 'desc' | ''
const rotate: { [key: string]: SortDirection } = { '': 'desc', desc: 'asc', asc: '' }

export interface SortEvent {
  column: string
  direction: SortDirection
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '(click)': 'rotate()',
    },
    standalone: false
})
export class NgbdSortableHeader {
  @Input() sortable: string
  @Input() direction: SortDirection = ''
  @Output() sort: EventEmitter<SortEvent> = new EventEmitter<SortEvent>()

  public rotate(): void {
    this.direction = rotate[this.direction]
    this.sort.emit({ column: this.sortable, direction: this.direction })
  }
}
